import React from 'react';

export type BgisModalProps = {
  children?: React.ReactNode;
};

const BgisModal  : React.FC<BgisModalProps> = ({ children }: BgisModalProps) => {

    return (<div id="defaultModal"  tabIndex={-1} aria-hidden="true" className="bgis-modal">
    <div className="bgis-modal-panel">
         
            
{children}

        
    </div>
</div>

);

}

export {BgisModal}